var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list"},_vm._l((_vm.tags),function(tag){return _c('li',{key:tag.id,staticClass:"list__item"},[_c('TagItem',{attrs:{"name":tag.name}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }